module.exports = __webpack_public_path__ + "static/media/loader.aa3d94fe.svg";